module.exports = __webpack_public_path__ + "static/img/bg-plane.16c06f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-plane.png
// module id = Vht8
// module chunks = 1